import { requestPasswordReset } from '../api.js';
import { getAuthCopy, translate } from '../i18n.js';

const html = String.raw;

export const renderForgotPasswordView = (container) => {
  const copy = getAuthCopy();
  const forgotCopy = copy.forgot ?? {};

  container.innerHTML = html`
    <div class="card stack">
      <h2>${forgotCopy.title ?? 'Passwort vergessen'}</h2>
      <p class="muted">${forgotCopy.subtitle ?? ''}</p>
      <form class="stack" id="forgot-password-form">
        <label>
          ${forgotCopy.emailLabel ?? copy.labels?.email ?? 'E-Mail'}
          <input type="email" name="email" required autocomplete="email" />
        </label>
        <button type="submit">${forgotCopy.submit ?? 'Reset-Link senden'}</button>
        <p class="muted" id="forgot-password-status"></p>
      </form>
      <p class="muted small">
        <a href="#/login">${forgotCopy.backToLogin ?? 'Zurück zum Login'}</a>
      </p>
    </div>
  `;

  const form = container.querySelector('#forgot-password-form');
  const statusEl = container.querySelector('#forgot-password-status');

  if (!form || !statusEl) {
    return;
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const data = new FormData(form);
    const email = data.get('email')?.toString() ?? '';
    statusEl.textContent = forgotCopy.sending ?? translate('common.loading');
    form.querySelectorAll('button').forEach((btn) => {
      btn.disabled = true;
    });
    try {
      await requestPasswordReset({ email });
      statusEl.textContent =
        forgotCopy.sent ?? 'Wenn ein Konto existiert, wurde eine E-Mail zum Zurücksetzen gesendet.';
      form.reset();
    } catch (error) {
      console.error(error);
      statusEl.textContent = error instanceof Error ? error.message : forgotCopy.error ?? 'Anfrage fehlgeschlagen.';
    } finally {
      form.querySelectorAll('button').forEach((btn) => {
        btn.disabled = false;
      });
    }
  });
};
